<template>
    <div>
        <template v-if="extrasArray && extrasArray.length > 0">
            <table class="w-100 dark mb-4">
                <tr class="fs-small">
                    <th class="extraNameWidth"></th>
                    <th class="pb-2 text-center">Availability</th>
                    <th class="pb-2 text-center">Price/unit</th>
                    <th class="addRemoveWidth"></th>
                </tr>
                <tr class="extraRow border-bottom-light border-top-light" v-for="extra in extrasArray">
                    <td class="darker fs-large pl-2">{{ extra.component.name }} - {{extra.componentPrice.name}}</td>
                    <td class="fs-small text-center">{{showAvailability(extra)}}</td>
                    <td class="fs-small text-center">{{ formatPrice(extra.componentPrice.grossprice) }} €</td>
                    <td class="d-flex flex-row justify-content-center py-2">
                        <span class="border-light py-2 px-3 radius-normal mx-2 text-center pointer" @click="changeExtraQtd2('remove', extra)"><i class="ico ico-minus dark fs-smaller m-0"></i></span>
                        <!-- <span class="border-light py-2 px-2 radius-normal mx-2 text-center darker font-weight-600" style="width: 2.2rem">{{extra.quantity}}</span> -->
                        <input type="number" placeholder="0" min="0" class="text-center fs-larger px-1 py-0 bg-lighter darker" style="width: 2.2rem" v-model="extra.quantity" @keyup="quantityChanged(extra)" @focus="extraFocused(extra)">
                        <span class="border-light py-2 px-3 radius-normal mx-2 text-center pointer" @click="changeExtraQtd2('add', extra)"><i class="ico ico-add dark fs-smaller m-0"></i></span>
                    </td>
                </tr>
                <tr class="fs-large">
                    <th class="pt-2 pl-2 extraNameWidth">Total</th>
                    <th class="pt-2 pb-2"></th>
                    <th class="pt-2 pb-2 text-center">{{formatPrice(getReservationCalculations.totalComponentGrossprice)}} €</th>
                    <th class="pt-2 addRemoveWidth text-center">{{totalExtras}}</th>
                </tr>
            </table>

        </template>

        <div v-else class="fs-large dark text-center p-2">
            There are no extras to show
        </div>

    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import { mapGetters, mapActions } from 'vuex'
export default {
    data: function() {
        return {
            extrasArray: null,
            extraItemLoaction: null
        }
    },
    props: {
        reservation: {
            type: Object
        },
    },
    created: function() {
        this.extrasArray = this.reservation.bookingComponents
    },
    mixins:[
        reservationsMixin
    ],
    computed: {
        ...mapGetters([
            'getReservationCalculations'
        ]),
        // extrasArray: function(){
        //     if(this.reservation.bookingComponents.length > 0){
        //         this.extraItemLoaction = 'component'
        //         return this.reservation.bookingComponents
        //     }else if(this.reservation.event.eventComponents.length > 0){
        //         this.extraItemLoaction = 'component'
        //         return this.reservation.event.eventComponents
        //     } else if(this.reservation.event.product.extras.length > 0){
        //         this.extraItemLoaction = 'item'
        //         return this.reservation.event.product.extras
        //     } else {
        //         return null
        //     }
        // },
        totalExtras: function(){
            let total = 0;

            for(let extra of this.extrasArray){
                if(extra.quantity){
                    total += Number(extra.quantity)
                }
            }
            this.$set(this.reservation, 'totalExtas', total)
            return total
        },
        hasSelectedExtras: function() {
            if(!this.extrasArray.length == 0){
                return false
            } else {
                let output = false;
                for(let extra of this.extrasArray){
                    if(extra.quantity > 0){
                        output = true
                    }
                }
                return output
            }
        },
    },
    methods: {
        ...mapActions([
            'setReservationCalculations'
        ]),
        showAvailability: function(extra) {
            if(extra.originalQuantity == 0){
                return 'unlimited'
            } else {
                return extra.quantityAvailable
            }
        },
        extraQtd: function(extra){
            let total = 0

            if(this.reservation.bookingComponents){
                var currentBookingComponent = this.reservation.bookingComponents.find(bookingComponent => {
                    if(bookingComponent.componentPrice){
                        return bookingComponent.component.id == extra.component.id && bookingComponent.componentPrice.id == extra.componentPrice.id
                    } else {
                        return bookingComponent.component.id == extra.component.id
                    }
                })

                if(currentBookingComponent){
                    total = currentBookingComponent.quantity
                }
            } else {
                total = extra.quantityBooked
            }

            return total
        },
        extraQtd2: function(extra){
            return extra.quantity
        },
        changeExtraQtd: function(addRemove, extra) {
            if(this.isReservationReadOnly){
                this.readOnlyShowMessage()
                return false
            }

            // if editing reservation
            //set the correct place to store this information
            if(this.reservation.bookingComponents){
                var currentBookingComponent = this.reservation.bookingComponents.find(bookingComponent => {
                    if(bookingComponent.componentPrice){
                        return bookingComponent.component.id == extra.component.id && bookingComponent.componentPrice.id == extra.componentPrice.id
                    } else {
                        return bookingComponent.component.id == extra.component.id
                    }
                })

                // if there was no extra before
                if(!currentBookingComponent){
                    let eventExtra = JSON.parse(JSON.stringify(extra))
                    this.reservation.bookingComponents.push(eventExtra)
                    currentBookingComponent = this.reservation.bookingComponents[this.reservation.bookingComponents.indexOf(eventExtra)]
                    currentBookingComponent.quantity = 0
                    currentBookingComponent.componentPrice = extra.componentPrice
                    delete currentBookingComponent.quantityBooked
                }


                //save quantity of bought extras to calculate how many more can be added (see 'add' below)
                if(!currentBookingComponent.quantityBoughtOnNewReservation){
                    this.$set(currentBookingComponent, 'quantityBoughtOnNewReservation', currentBookingComponent.quantity)
                }

                console.log('extra', extra);
                console.log('currentBookingComponent', currentBookingComponent);

                if(addRemove == 'add'){
                    // debug
                    // console.log('add here');
                    // console.log('currentBookingComponent.quantity '+ currentBookingComponent.quantity);
                    // console.log('currentBookingComponent.quantityBoughtOnNewReservation '+ currentBookingComponent.quantityBoughtOnNewReservation);
                    // console.log('extra.quantityAvailable '+ extra.quantityAvailable);
                    // example:
                    // if the event has 50 extras, and you create a reservation with 20 selecte, you are left with 30
                    // if you then edit the reservation you can add 30 more extras to a total of 50
                    if(extra.quantity == 0){
                        currentBookingComponent.quantity += 1
                    } else if(currentBookingComponent.quantity < currentBookingComponent.quantityBoughtOnNewReservation + extra.quantityAvailable){
                        currentBookingComponent.quantity += 1
                    }
                    console.log(currentBookingComponent.quantity + extra.quantityAvailable);

                } else if(addRemove == 'remove'){
                    if(currentBookingComponent.quantity > 0){
                        currentBookingComponent.quantity -= 1
                    }


                }

                //fix (also present on modal ReservationEdit.vue)
                this.fixQuantityBooked()

                //asks api for calculations
                this.setReservationCalculations(this.reservation);

            } else {
                // if creating reservation
                this.changeExtraQtdCreateReservation(addRemove, extra)
            }

        },
        changeExtraQtd2: function(addRemove, extra) {
            if(this.isReservationReadOnly){
                this.readOnlyShowMessage()
                return false
            }



            if(addRemove == 'add'){
                // is unlimied
                if(extra.originalQuantity == 0){
                extra.quantity++
                } else {
                    if(extra.quantityAvailable > 0){
                        extra.quantity++
                        extra.quantityAvailable--
                    }
                }

            } else if(addRemove == 'remove'){
                if(extra.quantity > 0){
                    extra.quantity--
                    // not unlimied
                    if(extra.originalQuantity != 0){
                        extra.quantityAvailable++
                    }
                }
            }

            //asks api for calculations
            this.setReservationCalculations(this.reservation);


        },
        changeExtraQtdCreateReservation: function(addRemove, extra) {
            if(addRemove == 'add'){

                if(!extra.quantityBooked){
                    // extra.quantityBooked = 0;
                    this.$set(extra, 'quantityBooked', 0)
                }
                if(extra.quantity == 0 || extra.quantityBooked < extra.quantityAvailable){
                // if(extra.quantity == 0 || extra.quantityBooked < this.extraQtd(extra)){
                    extra.quantityBooked++;
                }

            } else if(addRemove == 'remove'){

                if(extra.quantityBooked > 0){
                    extra.quantityBooked--;
                }

            }

            //if editing reservation set the total on the right part of the reservation object
            if(this.reservation.bookingComponents){
                this.reservation.bookingComponents.map(bookingComponent => {
                    if(bookingComponent.component.id == extra.component.id){
                        bookingComponent.quantity = extra.quantityBooked
                    }
                })
            }


            //asks api for calculations
            this.setReservationCalculations(this.reservation);
        },
        quantityChanged: function(extra){
            if(extra.quantity <= 0){
                extra.quantity = null
            }


            if(extra.originalQuantity != 0 && extra.quantity > extra.originalQuantity){
                extra.quantity = extra.originalQuantity
                this.$toasted.error('Selected quantity can not be higher than available quantity');
            }

            extra.quantityAvailable = extra.originalQuantity - extra.quantity

            this.setReservationCalculations(this.reservation);
        },
        extraFocused: function (extra) {
            // fix to simulate "placeholder" with 0 value
            if(extra.quantity == 0){
                extra.quantity = null
            }
        },
        fixQuantityBooked: function() {
            //when editing reservation the information on reservation.event.eventComponents[x] refers to the total sold of the event
            //so this fix set the reservation.event.eventComponents[x].quantityBooked to the same as in reservation.bookingComponents[x].quantity

            let vm = this

            // vm.reservation.bookingComponents.map(componentA => {
            for(var componentA of vm.reservation.bookingComponents){
                vm.reservation.event.eventComponents.map(componentToFix => {
                    if(componentA.component.id == componentToFix.component.id){
                        componentToFix.quantityBooked = componentA.quantity
                        vm.$set(componentToFix, 'fixed', true)
                    }
                })
            }

            // if there is any wrong quantity remaining (not fixed) will be set to zero
            vm.reservation.event.eventComponents.map(componentToFix => {
                if(!componentToFix.fixed){
                    componentToFix.quantityBooked = 0
                }
            })

        }
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ExtraSelector.vue?517b136a